import { MessageResponse } from "./messageResponse";
import { PensionProviderResponse } from "./pensionProviderResponse";

export class PensionProvidersResponse extends MessageResponse {
    providers: Array<PensionProviderResponse>;
    costComparisonOrder: Array<string>;
    findYourselfOrder: Array<string>;
}
